/* Amalvi landing page behaviour.
 *
 * Ported from index.html. The original VARIANTS array and fake add-to-cart
 * toast are gone — pack/colour selection and cart submission are handled by
 * the buy-box section itself (amalvi-buy-box.liquid), which has the real
 * Shopify variant data.
 *
 * Everything here is idempotent and re-runnable: sections can be added,
 * removed and reordered in the theme editor, which tears down and re-injects
 * DOM without a page load. Each initialiser marks what it has touched so a
 * second pass can't double-bind.
 */
(function () {
  'use strict';

  var DONE = 'data-amalvi-bound';

  function each(root, selector, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }

  /* ---------- star ratings ---------- */
  var STAR =
    'M12 2.6l2.83 5.86 6.36.8-4.67 4.37 1.2 6.27L12 16.85 6.28 19.9l1.2-6.27L2.81 9.26l6.36-.8L12 2.6Z';

  function initStars(root) {
    each(root, '.stars:not([' + DONE + '])', function (el) {
      el.setAttribute(DONE, '');
      var n = parseInt(el.dataset.r || '5', 10);
      var out = '';
      for (var i = 0; i < n; i++) {
        out += '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR + '"/></svg>';
      }
      el.innerHTML = out;
      el.setAttribute('role', 'img');
      el.setAttribute('aria-label', 'Rated ' + n + ' out of 5');
    });
  }

  /* ---------- accordions (buy box + FAQ) ---------- */
  /* One open at a time within a group; height animates, then unpins to `none`
     so nested content can grow (spec chips wrapping, etc). */
  function initAccordions(root) {
    each(root, '.acc-item:not([' + DONE + '])', function (item, i) {
      item.setAttribute(DONE, '');
      var head = item.querySelector('.acc-head');
      var body = item.querySelector('.acc-body');
      if (!head || !body) return;

      if (!body.id) {
        body.id =
          'acc-body-' + (item.closest('[id]') ? item.closest('[id]').id + '-' : '') + i;
      }
      head.setAttribute('aria-controls', body.id);
      head.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      if (item.classList.contains('open')) body.style.maxHeight = 'none';

      body.addEventListener('transitionend', function () {
        if (item.classList.contains('open')) body.style.maxHeight = 'none';
      });

      head.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        var group = item.parentElement;
        each(group, ':scope > .acc-item.open', function (o) {
          var ob = o.querySelector('.acc-body');
          if (ob.style.maxHeight === 'none') {
            ob.style.maxHeight = ob.scrollHeight + 'px';
            void ob.offsetHeight;
          }
          o.classList.remove('open');
          ob.style.maxHeight = null;
          o.querySelector('.acc-head').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- mobile nav ---------- */
  function initNav(root) {
    each(root, '[data-amalvi-nav-toggle]:not([' + DONE + '])', function (toggle) {
      toggle.setAttribute(DONE, '');
      var menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;

      function close() {
        menu.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = menu.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
      document.addEventListener('click', function (e) {
        if (menu.classList.contains('open') && !menu.contains(e.target) && e.target !== toggle) {
          close();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
      each(menu, 'a', function (a) {
        a.addEventListener('click', close);
      });
    });
  }

  /* ---------- quick-questions popup ---------- */
  function initHelp(root) {
    each(root, '[data-amalvi-help-fab]:not([' + DONE + '])', function (fab) {
      fab.setAttribute(DONE, '');
      var panel = document.getElementById(fab.getAttribute('aria-controls'));
      if (!panel) return;

      function close() {
        panel.classList.remove('open');
        fab.setAttribute('aria-expanded', 'false');
      }

      fab.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = panel.classList.toggle('open');
        fab.setAttribute('aria-expanded', String(open));
      });
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      document.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });

      each(panel, '.help-q > button', function (btn) {
        var q = btn.parentElement;
        var a = q.querySelector('.help-a');
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = q.classList.toggle('open');
          a.style.maxHeight = open ? a.scrollHeight + 'px' : null;
          btn.setAttribute('aria-expanded', String(open));
        });
      });
    });
  }

  /* ---------- "Choose Your Pack" scroll-to-buy-box ---------- */
  function initScrollCtas(root) {
    each(root, '.scroll-cta:not([' + DONE + '])', function (btn) {
      btn.setAttribute(DONE, '');
      btn.addEventListener('click', function () {
        var options = document.getElementById('amalvi-options');
        /* On pages without a buy box (cart, policies) send them to the
           landing page instead of doing nothing. */
        if (!options) {
          window.location.href = '/#buy-box';
          return;
        }
        options.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var sel = options.querySelector('.opt[aria-checked="true"]');
        if (sel) {
          setTimeout(function () {
            sel.focus({ preventScroll: true });
          }, 400);
        }
      });
    });
  }

  /* ---------- init ---------- */
  function init(root) {
    root = root || document;
    initStars(root);
    initAccordions(root);
    initNav(root);
    initHelp(root);
    initScrollCtas(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor re-renders a section's DOM in place — re-init just that part. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  window.AmalviInit = init;
})();
